import * as React from 'react';

export const MasteryLevel4SVG = () => (
  <svg width="38" height="44" viewBox="0 0 38 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M33.4545 13.6547L19 5.3094L4.54552 13.6547V30.3453L19 38.6906L33.4545 30.3453V13.6547Z"
      fill="var(--cds-color-yellow-25)"
      stroke="var(--cds-color-yellow-500)"
      strokeWidth="4"
    />
    <path
      d="M16.6506 23.94H19.9906V21.06C19.9906 20.6867 20.0039 20.2467 20.0306 19.74C20.0573 19.2333 20.0773 18.7933 20.0906 18.42H20.0106C19.8506 18.7533 19.6839 19.08 19.5106 19.4C19.3373 19.72 19.1573 20.0533 18.9706 20.4L16.6506 23.94ZM19.9906 29V25.72H14.3706V24.16L19.4106 16.28H22.1506V23.94H23.7506V25.72H22.1506V29H19.9906Z"
      fill="black"
    />
  </svg>
);
